import React, { useEffect, useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { setIsLoading } from '../general/actions';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import { currencyFormater } from '../general/utils';

function Print(props) {
    const { setIsLoading, is_provider } = props;

    const [order, setOrder] = useState({});
    const [orderDetail, setOrderDetail] = useState([]);

    const [fontSize, setFontSize] = useState(parseFloat(localStorage.fontSize) || 0.6);
    const [maxCharsDesc, setMaxCharsDesc] = useState(parseInt(localStorage.maxCharsDesc) || 350);
    const [printOrder, setPrintOrder] = useState(true);
    const [printRemision, setPrintRemision] = useState(is_provider);
    const [pageBreak, setPageBreak] = useState(false);

    const [show, setShow] = useState(props.show);
    const [idPrint, setIdPrint] = useState(props.idPrint);

    const onClose = () => {
        if (typeof props.onClose === 'function') props.onClose();
        setShow(false);
        props.setIdPrint('');
        props.setShow(false);
    };

    useEffect(() => { setShow(props.show); }, [props.show]);
    useEffect(() => { setIdPrint(props.idPrint); }, [props.idPrint]);
    useEffect(() => { localStorage.fontSize = fontSize || '0.7'; }, [fontSize]);
    useEffect(() => { localStorage.maxCharsDesc = maxCharsDesc || '350'; }, [maxCharsDesc]);

    useEffect(() => {
        if (idPrint) {
            getOrderData(idPrint);
            setMaxCharsDesc(parseInt(localStorage.maxCharsDesc) || maxCharsDesc);
            setFontSize(parseFloat(localStorage.fontSize) || fontSize);
        }
    }, [idPrint]);

    const getOrderData = async (id) => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get('/orders/print/' + id);
            setOrder(response.data);
            setOrderDetail(response.data.order_detail);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleImprimir = () => {
        // Solo captura los documentos visibles (display !== 'none')
        const papers = Array.from(
            document.querySelectorAll('#print-papers .print-paper')
        ).filter(el => el.style.display !== 'none');

        const separator = pageBreak
            ? ''
            : '<hr style="border:none;border-top:1px dashed #aaa;margin:20px 0;" />';

        const contenido = papers.map((el, i) => {
            const breakStyle = pageBreak && i < papers.length - 1
                ? ' style="page-break-after: always;"'
                : '';
            return `<div class="print-paper"${breakStyle}>${el.innerHTML}</div>${i < papers.length - 1 ? separator : ''}`;
        }).join('');

        const ventana = window.open('', '_blank');
        ventana.document.write(`
            <html>
            <head>
                <title>Pedido ${idPrint}</title>
                <style>
                    @page { margin: 1.5cm; }
                    * { box-sizing: border-box; }
                    body {
                        font-family: 'Calibri', sans-serif;
                        font-size: ${fontSize}rem;
                        margin: 0;
                        background: #fff;
                        color: #000;
                    }
                    .print-paper { max-width: 100%; margin: 0; padding: 0; font-size: ${fontSize}rem; }
                    table { border-collapse: collapse; width: 100%; font-size: inherit; }
                    th, td { padding: 3px 5px; vertical-align: top; font-size: inherit; }
                    .border table, .border th, .border td { border: 1px solid #000; }
                    .text-end   { text-align: right; }
                    .text-start { text-align: left; }
                    small { font-size: 0.85em; }
                </style>
            </head>
            <body>${contenido}</body>
            </html>
        `);
        ventana.document.close();
        ventana.print();
        ventana.close();
    };

    const adjFontSize = (delta) => {
        setFontSize(prev => parseFloat(Math.max(0.4, Math.min(1.4, prev + delta)).toFixed(3)));
    };

    return (
        <Modal show={show} onHide={onClose} size="xl" fullscreen="lg-down">
            {/* ── Header ── */}
            <Modal.Header
                closeButton
                className="no-print"
                style={{ background: '#f8fafc', borderBottom: '1px solid var(--abi-border)' }}
            >
                <Modal.Title style={{ fontWeight: 800, fontSize: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                    <i className="fa fa-print" style={{ color: 'var(--abi-primary)' }} />
                    Vista previa de impresión
                    <span style={{
                        background: 'var(--abi-primary)', color: '#fff',
                        borderRadius: 8, padding: '2px 10px', fontSize: 13, fontWeight: 700
                    }}>
                        # {idPrint}
                    </span>
                </Modal.Title>
            </Modal.Header>

            {/* ── Preview area ── */}
            <Modal.Body
                className="print-preview-stage no-print"
                style={{ padding: '24px 0', minHeight: '60vh', overflowY: 'auto' }}
            >
                <div id="print-papers">
                {/* Pedido */}
                <div
                    className="print-paper no-print-shadow"
                    style={{
                        display: printOrder ? 'block' : 'none',
                        fontSize: `${fontSize}rem`,
                    }}
                >
                    <p style={{ textAlign: 'right' }}>Creación: {order.created_at}</p>
                    Señores: <b>{order.agreement && order.agreement.provider.name}</b> {' '}
                    {order.agreement && order.agreement.provider.address}
                    {' Tel: '}{order.agreement && order.agreement.provider.phone}
                    <br />
                    <p style={{ textAlign: 'justify', margin: '10px 0' }}>
                        Cordial saludo, favor proceder de acuerdo al contrato{' '}
                        <b>{order.agreement && order.agreement.ext_id}</b>
                        , y suministrar la siguiente solicitud de servicio, teniendo en cuenta
                        la calidad de los productos y oportunidad en la entrega.
                    </p>

                    <table cellSpacing="0.2rem" width="100%">
                        <thead>
                            <tr>
                                <td><b>Pedido: {idPrint}</b></td>
                                <th style={{ textAlign: 'left' }}>
                                    {order.agreement && order.agreement.customer.name}
                                    {' '}Centro de Costos {order.fund && order.fund.department.id}: {order.fund && order.fund.department.name}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowSpan="2"><b>Entrega:</b></td>
                                <td><b>Fecha: </b>{order.delivery_date} <b>Hora: </b>{order.delivery_time}</td>
                            </tr>
                            <tr>
                                <td><b>Dirección: </b>{order.delivery_address} <b>Evento:</b> {order.delivery_event_name}</td>
                            </tr>
                            <tr>
                                <td><b>Recibe:</b></td>
                                <td>{order.delivery_person_receiving} <b>Teléfono: </b>{order.delivery_phone}</td>
                            </tr>
                            <tr>
                                <td><b>Fondo:</b></td>
                                <td>{order.fund && order.fund.id}: {order.fund && order.fund.ext_id} {order.fund && order.fund.name}</td>
                            </tr>
                            <tr>
                                <td><b>Interventor Operativo:</b></td>
                                <td>
                                    {order.user && order.user.id}: {order.user && order.user.name}
                                    <b> email: </b>{order.user && order.user.email}
                                </td>
                            </tr>
                            {order.sub_locality && (
                                <tr>
                                    <td><b>Sector / Localidad:</b></td>
                                    <td>{order.sub_locality.name}</td>
                                </tr>
                            )}
                            <tr>
                                <td><b>Notas:</b></td>
                                <td>{order.notes}</td>
                            </tr>
                            <tr>
                                <td><b>Firma Interventor Administrativo:</b></td>
                                <td>________________________________________</td>
                            </tr>
                        </tbody>
                    </table>

                    <br />

                    <table cellSpacing="0.2rem" className="border" width="100%">
                        <thead>
                            <tr>
                                <th>Producto</th>
                                <th>Cantidad</th>
                                <th>Precio</th>
                                <th>IVA</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderDetail.map(det => (
                                <React.Fragment key={'det1-' + det.id}>
                                    <tr>
                                        <td>{det.product.id}: {det.product.name}</td>
                                        <td className="text-end">{det.quantity}</td>
                                        <td className="text-end">{currencyFormater(det.price)}</td>
                                        <td className="text-end">{det.taxes}%</td>
                                        <td className="text-end">{currencyFormater(det.total_amount)}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={5}>
                                            <small>
                                                <b>Detalle: </b>
                                                {det.product.description.slice(0, maxCharsDesc)}
                                                {det.product.description.length > maxCharsDesc ? '…' : ''}
                                            </small>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan={5} className="text-end">
                                    Valor Total: {currencyFormater(order.total_amount)}
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                {/* Separador entre documentos */}
                {printOrder && printRemision && !pageBreak && (
                    <hr style={{
                        border: 'none',
                        borderTop: '1px dashed #aaa',
                        margin: '20px 0',
                    }} />
                )}

                {/* Remisión */}
                <div
                    className="print-paper"
                    style={{
                        display: printRemision ? 'block' : 'none',
                        fontSize: `${fontSize}rem`,
                        marginTop: printOrder && pageBreak ? 32 : 0,
                    }}
                >
                    <table width="100%">
                        <tbody>
                            <tr>
                                <th>
                                    {order.agreement && order.agreement.provider.ext_id}{' '}
                                    {order.agreement && order.agreement.provider.name}
                                    {' Teléfono: '}{order.agreement && order.agreement.provider.phone}
                                </th>
                                <td><b>Pedido: {idPrint}</b></td>
                                <td><b>Remisión: _______</b></td>
                            </tr>
                        </tbody>
                    </table>
                    <br />
                    <table cellSpacing="0.2rem" width="100%">
                        <tbody>
                            <tr>
                                <td><b>Cliente:</b></td>
                                <td>
                                    {order.agreement && order.agreement.customer.ext_id}{' '}
                                    {order.agreement && order.agreement.customer.name}
                                </td>
                            </tr>
                            <tr>
                                <td rowSpan="2"><b>Entrega:</b></td>
                                <td><b>Fecha: </b>{order.delivery_date} <b>Hora: </b>{order.delivery_time}</td>
                            </tr>
                            <tr>
                                <td><b>Dirección: </b>{order.delivery_address} <b>Evento:</b> {order.delivery_event_name}</td>
                            </tr>
                            <tr>
                                <td><b>Recibe:</b></td>
                                <td>{order.delivery_person_receiving} <b>Teléfono: </b>{order.delivery_phone}</td>
                            </tr>
                            <tr>
                                <td><b>Fondo:</b></td>
                                <td>
                                    {order.fund && order.fund.id}: {order.fund && order.fund.ext_id} {order.fund && order.fund.name}
                                    {' '}<b>Centro de Costos </b>
                                    {order.fund && order.fund.department.id}: {order.fund && order.fund.department.name}
                                </td>
                            </tr>
                            {order.sub_locality && (
                                <tr>
                                    <td><b>Sector / Localidad:</b></td>
                                    <td>{order.sub_locality.name}</td>
                                </tr>
                            )}
                             <tr>
                                <td><b>Notas:</b></td>
                                <td>{order.notes}</td>
                            </tr>
                        </tbody>
                    </table>
                    <br />
                    <table cellSpacing="0.2rem" className="border" width="100%">
                        <thead>
                            <tr>
                                <th>Producto</th>
                                <th>Cantidad</th>
                                <th>Precio</th>
                                <th>IVA</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderDetail.map(det => (
                                <React.Fragment key={'det2-' + det.id}>
                                    <tr>
                                        <td>{det.product.id}: {det.product.name}</td>
                                        <td className="text-end">{det.quantity}</td>
                                        <td className="text-end">{currencyFormater(det.price)}</td>
                                        <td className="text-end">{det.taxes}%</td>
                                        <td className="text-end">{currencyFormater(det.total_amount)}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={5}>
                                            <small>
                                                <b>Detalle: </b>
                                                {det.product.description.slice(0, maxCharsDesc)}
                                                {det.product.description.length > maxCharsDesc ? '…' : ''}
                                            </small>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan={5} className="text-end">
                                    Valor Total: {currencyFormater(order.total_amount)}
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                    <br />
                    <table width="100%">
                        <tbody>
                            <tr>
                                <th>Recibido:</th>
                                <td><br />Firma______________________________</td>
                                <td><br />Cc.______________________________</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>{/* /print-papers */}
            </Modal.Body>

            {/* ── Footer de controles ── */}
            <Modal.Footer
                className="no-print"
                style={{
                    background: '#f8fafc',
                    borderTop: '1px solid var(--abi-border)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 12,
                }}
            >
                {/* Controles izquierda */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
                    {/* Tamaño de letra */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{ fontSize: 12, color: 'var(--abi-muted)', fontWeight: 600 }}>Letra</span>
                        <div className="print-font-stepper">
                            <button onClick={() => adjFontSize(-0.025)} title="Reducir">−</button>
                            <span>{(fontSize * 10).toFixed(1)}</span>
                            <button onClick={() => adjFontSize(+0.025)} title="Aumentar">+</button>
                            <button onClick={() => setFontSize(0.6)} title="Restablecer" style={{ fontSize: 10, padding: '0 6px' }}>↺</button>
                        </div>
                    </div>

                    {/* Caracteres descripción */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{ fontSize: 12, color: 'var(--abi-muted)', fontWeight: 600 }}>Desc. máx.</span>
                        <input
                            type="number"
                            value={maxCharsDesc}
                            onChange={(e) => setMaxCharsDesc(e.target.value)}
                            style={{
                                width: 68, border: '1px solid var(--abi-border)',
                                borderRadius: 7, padding: '4px 8px', fontSize: 13,
                                outline: 'none',
                            }}
                        />
                    </div>

                    {/* Documentos (solo proveedor) */}
                    {is_provider && (
                        <div style={{ display: 'flex', gap: 14 }}>
                            <Form.Check
                                type="switch" id="sw-pedido"
                                label="Pedido"
                                checked={printOrder}
                                onChange={(e) => setPrintOrder(e.target.checked)}
                                style={{ fontSize: 13 }}
                            />
                            <Form.Check
                                type="switch" id="sw-remision"
                                label="Remisión"
                                checked={printRemision}
                                onChange={(e) => setPrintRemision(e.target.checked)}
                                style={{ fontSize: 13 }}
                            />
                        </div>
                    )}

                    {/* Salto de página */}
                    <Form.Check
                        type="switch" id="sw-pagebreak"
                        label="Salto de página"
                        checked={pageBreak}
                        onChange={(e) => setPageBreak(e.target.checked)}
                        style={{ fontSize: 13 }}
                    />
                </div>

                {/* Acciones derecha */}
                <div style={{ display: 'flex', gap: 8 }}>
                    <Button variant="outline-secondary" size="sm" onClick={onClose}>
                        Cerrar
                    </Button>
                    <Button variant="primary" size="sm" onClick={handleImprimir}>
                        <i className="fa fa-print" /> Imprimir
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

function mapStateToProps(state) {
    return {
        isLoading: state.isLoading,
        is_provider: state.is_provider,
    };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(Print);
